













































import { Component, PropSync, Vue } from 'vue-property-decorator';
import UpdateProofOfAddressWealthSuccessViewModel
  from '@/vue-app/view-models/components/user-profile/user-profile-tabs/user-profile-my-documents-tab/update-proof-of-address/update-proof-of-address-wealth-success-view-model';

@Component({ name: 'UpdateProofOfAddressWealthSuccess' })
export default class UpdateProofOfAddressWealthSuccess extends Vue {
  @PropSync('isOpen', { type: Boolean, required: true })
  synced_is_open!: boolean;

  update_proof_wealth_success_view_model = Vue.observable(
    new UpdateProofOfAddressWealthSuccessViewModel(),
  );

  closeModal() {
    this.synced_is_open = false;
  }
}
